import {unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Logger} from 'typings/portaro.be.types';

export default class LoggerDataService {
    public static serviceName = 'loggerDataService';

    private static readonly ROUTE = 'loggers';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getLoggers(): Promise<Logger[]> {
        return this.Restangular
                   .all(LoggerDataService.ROUTE)
                   .getList();
    }

    @ngAsync()
    @unRestangularize()
    public async changeLevel(loggerId: string, level: string): Promise<Logger> {
        return this.Restangular
                   .one(LoggerDataService.ROUTE, loggerId)
                   .get({level});
    }
}
